import React from 'react';
import { useTranslation } from 'react-i18next';

const SchachermayerAttachmentLabel = ({
    isSource,
    file,
    onSelectedFileToSwapChange,
}: {
    isSource: boolean;
    file: any;
    onSelectedFileToSwapChange?: (file: any) => void;
}) => {
    const { t } = useTranslation('assistance');

    if (isSource) {
        return (
            <span className="ml-auto px-2 h-6 leading-6 bg-surface-brand-weak rounded text-content-strong text-xs font-medium border-line-brand-weak border">
                {t('attachments.sourceData')}
            </span>
        );
    }

    return (
        <div className="ml-auto flex gap-2">
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    if (onSelectedFileToSwapChange) {
                        onSelectedFileToSwapChange(file);
                    }
                }}
                className="px-2 h-6 leading-6 bg-surface-brand-weak rounded text-content-strong text-xs font-medium border-line-brand-weak border hover:bg-secondary transition-colors"
            >
                {t('attachments.makeSourceData')}
            </button>
        </div>
    );
};

export default SchachermayerAttachmentLabel;
